module.exports = __webpack_public_path__ + "84b8c38693fd8e5ffcb1565a6c0f4445.pdf";